import { Flex, Grid, Text } from 'theme-ui';
import formatMoney from '~/utils/format-money';

type Props = {
  title: string | null;
  subtitle: string | null;
  price: number | null;
  regularPrice: number | null;
  slug: string | null;
  isKit?: boolean;
  showReviews?: boolean | null;
};

const PDPDetails = ({ title, subtitle, price, regularPrice, slug, isKit, showReviews }: Props) => {
  return (
    <Grid sx={{ gap: '0.8rem' }}>
      <Flex
        sx={{
          justifyContent: 'space-between',
          borderBottom: isKit ? '1px solid' : null,
          borderColor: isKit ? 'cloud' : null,
          pb: isKit ? 'var(--vertical-spacing)' : null,
        }}
      >
        <Flex sx={{ flexDirection: 'column', gap: '0.8rem' }}>
          {title ? <Text as="h1" variant="PDPTitle" dangerouslySetInnerHTML={{ __html: title }} /> : null}
          <Text
            as="h3"
            variant="PDPSubTitle"
            sx={{
              color: 'UIGray1',
            }}
          >
            {subtitle}
          </Text>
        </Flex>

        <Flex sx={{ flexDirection: 'column', alignItems: 'flex-end', gap: '0.8rem' }}>
          <Text variant="PDPTitle">{formatMoney(price)}</Text>
          {price !== regularPrice && (
            <Text
              variant="PDPSubTitle"
              sx={{
                textDecorationLine: 'line-through',
                color: 'UIGray1',
              }}
            >
              {formatMoney(regularPrice)}
            </Text>
          )}
        </Flex>
      </Flex>
      {!isKit && showReviews && (
        <div
          sx={{ '.yotpo-sr-bottom-line-text': { fontFamily: 'inherit !important' } }}
          className="yotpo-widget-instance"
          data-yotpo-instance-id="778820"
          data-yotpo-product-id={slug}
        />
      )}
    </Grid>
  );
};

export default PDPDetails;
